// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout-module--wrapper--zZxlG"};